import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/rootReducer";

import { GetStartedState } from "./getStartedSlice";

function getStarted(state: RootState): GetStartedState {
  return state.getStarted;
}

export const selectInitialDetails = createSelector(getStarted, state => state.initialDetails);
export const selectAIData = createSelector(getStarted, state => state.ai);
